import { useState } from "react";
import { faqs } from "../../../mocks/guaData";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-[880px] px-4 md:px-6">
        <SectionHead
          align="center"
          eyebrow="常见问题 · FAQ"
          title="关于吃瓜，你可能想问"
          desc="以下问题与页面中的问答结构一一对应，方便搜索引擎与读者快速定位。"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
              })),
            }),
          }}
        />
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={i * 40}>
                <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  >
                    <span className="flex items-center gap-3 font-heading text-base font-bold text-foreground-900">
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-black text-primary-600">
                        Q
                      </span>
                      {f.q}
                    </span>
                    <i
                      className={`ri-add-line shrink-0 text-xl text-foreground-500 transition-transform ${isOpen ? "rotate-45" : ""}`}
                      aria-hidden="true"
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="border-t border-background-200 bg-background-100/60 px-5 py-4 md:px-6">
                      <p className="text-[15px] leading-8 text-foreground-700">{f.a}</p>
                    </div>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}